import React, { ReactNode } from "react";
import List, { ListProps } from "@mui/material/List";
import { ListItem, ListItemProps } from "@mui/material";

export type WcList = ListProps & {
  children?: ReactNode;
};

export const WcList = ({ children, ...props }: ListProps) => (
  <List {...props}>{children}</List>
);

export default WcList;

export type WcListItem = ListItemProps & {
  children?: ReactNode;
};

export const WcListItem = ({ children, ...props }: ListItemProps) => (
  <ListItem {...props}>{children}</ListItem>
);
